<template>
  <b-nav-item-dropdown right>
    <template slot="button-content">
      {{ $t("categories_dropdown.departments") }}
    </template>
    <dropdown-submenu
      v-for="(category, index) in categories"
      :key="index"
    >
      <template slot="button-content">
        {{ $tradukojTranslate(category.name) }}
      </template>
      <b-dropdown-item
        v-for="(subcategory, index) in category.subcategories"
        :key="index"
        :to="subcategoryRoute(subcategory, category.department || category.uuid)"
      >
        {{ $tradukojTranslate(subcategory.name) }}
      </b-dropdown-item>
    </dropdown-submenu>
  </b-nav-item-dropdown>
</template>


<script>
import DropdownSubmenu from "@/components/navigation/DropdownSubmenu";
import CategoriesNavItem from "@/components/navigation/CategoriesNavItem";

export default {
  name: "categories-nav-item-dropdown",
  components: {
    DropdownSubmenu,
  },
  extends: CategoriesNavItem,
  fallbackI18n: {
    messages: {
      und: {
        categories_dropdown: {
          departments: "Departments",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
::v-deep .dropdown-toggle {
  white-space: normal;
}
</style>
